import React from 'react';
import {connect} from 'react-redux';
import {isValidDuns, isValidUei} from 'common/utils';
import {Card, Header, Message, Form, Button, Icon, List} from 'semantic-ui-react';
import REST from 'go/requests/rest';
import {InlineTextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import _ from 'lodash';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: undefined,
  num: '',
};

const SAMGOV_CONNECTIVITY_MSG =
  "Sorry, we can't verify your organization at this time due to connectivity issues. Please try again later.";

export class DunsLookupCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;

    this.dunsToUei = _.includes(this.props.toggles, 'dunsToUEI');
    this.orgCardTitle = this.dunsToUei
      ? 'Accessing your organization'
      : 'Search for your organization POCs';
    this.INVALID_ID_MSG = this.dunsToUei
      ? 'You must enter a valid Unique Entity Identifier and EFT indicator combination (12 character UEI or 12 character UEI-4 character EFT).'
      : 'Please enter a valid 9 or 13 digit number';
  }

  componentDidMount() {}

  handleChange = (e) => {
    this.setState({
      num: e.target.value,
      error: undefined,
      data: undefined,
    });
  };

  triageResponse = (response) => {
    if (response.ok) {
      return forceJsonResponse(response, MONO);
    } else if (response.status === 404) {
      this.setState({loading: false, error: 'notFound'});
    } else if (response.status === 400) {
      forceJsonResponse(response).then((res) => {
        this.setState({loading: false, error: res.reason});
      });
    } else if (response.status === 503 || response.status === 504) {
      this.setState({loading: false, error: 'samGovIssue'});
    } else {
      this.setState({loading: false, error: 'httpError'});
    }
  };

  handleSubmit = (e) => {
    const idNum = this.state.num;
    e.preventDefault();
    const validator = this.dunsToUei ? isValidUei : isValidDuns;
    if (validator(idNum)) {
      this.submitHttpRequest();
    } else {
      this.setState({error: 'invalidId'});
    }
  };

  submitHttpRequest = () => {
    const idNum = this.state.num.trim();

    this.setState({loading: true, error: undefined});

    if (this.dunsToUei) {
      return REST.organization
        .getOrganizationByUEIFromSAMGOV(this.props.jwt, idNum)
        .then(this.triageResponse)
        .then((res) => {
          if (res) {
            this.setState({
              data: res,
            });
          }
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          console.error('error');
          this.setState({
            loading: false,
            error: true,
          });
        });
    } else {
      return REST.organization
        .getOrganizationByDUNSFromSAMGOV(this.props.jwt, idNum)
        .then(this.triageResponse)
        .then((res) => {
          if (res) {
            res.contacts.forEach((c) => {
              if (c.type === 'ELECTRONIC') {
                res.EPOC = c.email;
              }
            });

            res.addresses.forEach((a) => {
              if (a.type === 'PHYSICAL') {
                res.physicalAddress = a;
              }
            });

            this.setState({
              data: res,
            });
          }
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          console.error('error');
          this.setState({
            loading: false,
            error: true,
          });
        });
    }
  };
  isEPOC(contact) {
    return (
      contact.type === 'ELECTRONIC' ||
      contact.type === 'ALT_ELECTRONIC' ||
      contact.contactType === 'ELECTRONIC' ||
      contact.contactType === 'ALT_ELECTRONIC'
    );
  }
  filterOrganizationContacts(orgContacts) {
    let contacts = [];
    _.forEach(orgContacts, (orgContact) => {
      let x = _.get(orgContact, 'organizationContact.contact');
      contacts.push(x);
    });
    return contacts;
  }

  dunsResponse() {
    const {data} = this.state;
    const {isInGmm} = data;
    if (isInGmm) {
      return (
        <Message info icon>
          <Icon name="info circle" size="large" />
          <Message.Content>
            <Message.Header>Organization is already registered</Message.Header>
            Your organization already exists in FEMA GO. Please contact one of the
            following electronic business POCs for this organization to be added:{' '}
            {data.contacts.filter(this.isEPOC).map((contact) => (
              <li>
                {' '}
                {contact.firstName} {'  '}
                {contact.lastName}
              </li>
            ))}{' '}
          </Message.Content>
        </Message>
      );
    } else {
      return (
        <Message error icon>
          <Icon name="warning sign" size="large" />

          <Message.Content>
            <Message.Header>You cannot add this organization</Message.Header>
            The{' '}
            <a
              target="_blank"
              href="http://www.sam.gov"
              rel="noopener noreferrer"
              title="SAM.gov"
            >
              {' '}
              SAM.gov{' '}
            </a>
            eBiz POC must create an account and add this organization.{' '}
            {data.EPOC ? (
              <React.Fragment>
                The eBiz POC for the organization you are trying to add is{' '}
                <a href={`mailto:${data.EPOC}`}>{data.EPOC}</a>
              </React.Fragment>
            ) : (
              `There was no eBiz POC found for this organization.`
            )}
          </Message.Content>
        </Message>
      );
    }
  }

  ueiResponse() {
    const {data} = this.state;
    const isInGmm = data.length;
    if (isInGmm == 1) {
      let contacts = this.filterOrganizationContacts(
        _.get(data, [0, 'organizationContacts'])
      );
      return (
        <Message info icon>
          <Icon name="info circle" size="large" />
          <Message.Content>
            <Message.Header>Organization is already registered</Message.Header>
            Your organization already exists in FEMA GO. Please contact one of the
            following electronic business POCs for this organization to be added:{' '}
            {_.map(contacts.filter(this.isEPOC), (contact) => (
              <li>
                {' '}
                {contact.firstName} {'  '}
                {contact.lastName}
              </li>
            ))}{' '}
          </Message.Content>
        </Message>
      );
    } else {
      return (
        <Message
          warning
          icon="warning sign"
          header="Multiple organizations found"
          content="Multiple organizations were found in SAM.gov matching that UEI number. Please verify that you entered the correct UEI number."
        />
      );
    }
  }

  render() {
    const {data, num, error, loading} = this.state;
    const showInput = !data || !(!data.isInGmm && data.userIsEPOC);
    const appDevAndSubToggle = _.includes(this.props.toggles, 'appDevAndSub1-1');

    if (this.dunsToUei) {
      if (appDevAndSubToggle) {
        return (
          <Card fluid id="orgDunsAdd">
            <Card.Content>
              {showInput && (
                <Form onSubmit={this.handleSubmit}>
                  <InlineTextBoxField
                    label="Search by UEI or UEI-EFT"
                    id="dunsInput"
                    disabled={loading}
                    value={num}
                    placeholder="123456789123-1234"
                    handleChange={this.handleChange}
                    displayError={error === 'invalidId'}
                    errorMessages={this.INVALID_ID_MSG}
                  />
                  <Form.Field>
                    <Button primary disabled={loading} loading={loading}>
                      Search
                    </Button>
                  </Form.Field>
                </Form>
              )}
              <br></br>
              <p>
                {' '}
                If you are not associated with your organization yet, find your point of
                contact to give you access.
              </p>
              <p>
                The electronic business point of contact from your sam.gov registration is
                identified as the point of contact for your organization. They must
                register in FEMA GO to help you gain access using their same email address
                as their sam.gov registration. You can go to{' '}
                <a
                  className="duns-link"
                  target="_blank"
                  href="https://sam.gov/content/help"
                >
                  sam.gov
                </a>{' '}
                for more help.
              </p>
              <p>
                Enter your Unique Entity Identifier (UEI) and Electronic Funds Transfer
                (EFT) indicator (if applicable) to find the names of your electronic
                business point of contacts.
              </p>
              {data && this.ueiResponse()}
              {error === 'notFound' && (
                <Message
                  warning
                  icon="warning sign"
                  header="Organization not found"
                  content="This UEI-EFT combination does not exist. "
                />
              )}
              {error === 'samGovIssue' && (
                <Message
                  error
                  icon="warning sign"
                  header="Something went wrong"
                  content={SAMGOV_CONNECTIVITY_MSG}
                />
              )}
            </Card.Content>
          </Card>
        );
      } else {
        return (
          <Card fluid id="orgDunsAdd">
            <Card.Content>
              <Header as="h3">
                <Icon name="plus" /> {this.orgCardTitle}
              </Header>
              <p>
                {' '}
                If you are not associated with your organization yet, find your point of
                contact to give you access.
              </p>
              <p>
                The electronic business point of contact from your sam.gov registration is
                identified as the point of contact for your organization. They must
                register in FEMA GO to help you gain access using their same email address
                as their sam.gov registration. You can go to{' '}
                <a
                  className="duns-link"
                  target="_blank"
                  href="https://sam.gov/content/help"
                >
                  sam.gov
                </a>{' '}
                for more help.
              </p>
              <p>
                Enter your Unique Entity Identifier (UEI) and Electronic Funds Transfer
                (EFT) indicator (if applicable) to find the names of your electronic
                business point of contacts.
              </p>
              {showInput && (
                <Form onSubmit={this.handleSubmit}>
                  <InlineTextBoxField
                    label="Search by UEI or UEI-EFT"
                    id="dunsInput"
                    disabled={loading}
                    value={num}
                    placeholder="123456789123-1234"
                    handleChange={this.handleChange}
                    displayError={error === 'invalidId'}
                    errorMessages={this.INVALID_ID_MSG}
                  />
                  <Form.Field>
                    <Button primary disabled={loading} loading={loading}>
                      Search
                    </Button>
                  </Form.Field>
                </Form>
              )}
              {data && this.ueiResponse()}
              {error === 'notFound' && (
                <Message
                  warning
                  icon="warning sign"
                  header="Organization not found"
                  content="This UEI-EFT combination does not exist. "
                />
              )}
              {error === 'samGovIssue' && (
                <Message
                  error
                  icon="warning sign"
                  header="Something went wrong"
                  content={SAMGOV_CONNECTIVITY_MSG}
                />
              )}
            </Card.Content>
          </Card>
        );
      }
    } else {
      if (appDevAndSubToggle) {
        return (
          <Card fluid id="orgDunsAdd">
            <Card.Content>
              {showInput && (
                <Form onSubmit={this.handleSubmit}>
                  <InlineTextBoxField
                    label="Enter your DUNS number"
                    id="dunsInput"
                    disabled={loading}
                    value={num}
                    handleChange={this.handleChange}
                    displayError={error === 'invalidId'}
                    errorMessages={this.INVALID_ID_MSG}
                  />
                  <Form.Field>
                    <Button primary disabled={loading} loading={loading}>
                      Search
                    </Button>
                  </Form.Field>
                </Form>
              )}
              <br></br>
              <p>FEMA GO automatically adds your organization from SAM.gov.</p>
              <List bulleted>
                <List.Item>
                  If you are the eBIZ POC, you will automatically see your organization if
                  you registered in FEMA GO with the same email address.
                </List.Item>
                <List.Item>
                  If you are not the eBiz POC please search for them using your DUNS#
                  below and contact them to be added to your organization.
                </List.Item>
              </List>
              <p>
                You can use the{' '}
                <a
                  className="duns-link"
                  target="_blank"
                  href="https://www.dnb.com/duns-number/lookup.html"
                >
                  DUNS Number lookup tool
                </a>{' '}
                to find your DUNS number, or the{' '}
                <a
                  className="duns-link"
                  target="_blank"
                  href="http://fedgov.dnb.com/webform/displayHomePage.do"
                >
                  DUNS Request Service
                </a>{' '}
                to request a new DUNS Number.
              </p>
              {data && this.dunsResponse()}
              {error === 'notFound' && (
                <Message
                  warning
                  icon="warning sign"
                  header="Organization not found"
                  content="No organizations were found in SAM.gov matching that DUNS number. Please verify that you entered the correct DUNS number."
                />
              )}
              {error === 'multipleFound' && (
                <Message
                  warning
                  icon="warning sign"
                  header="Multiple organizations found"
                  content="Multiple organizations were found in SAM.gov matching that DUNS number. Please verify that you entered the correct DUNS number."
                />
              )}
              {error === 'samGovIssue' && (
                <Message
                  error
                  icon="warning sign"
                  header="Something went wrong"
                  content={SAMGOV_CONNECTIVITY_MSG}
                />
              )}
            </Card.Content>
          </Card>
        );
      } else {
        return (
          <Card fluid id="orgDunsAdd">
            <Card.Content>
              <Header as="h3">
                <Icon name="plus" /> {this.orgCardTitle}
              </Header>
              <p>FEMA GO automatically adds your organization from SAM.gov.</p>
              <List bulleted>
                <List.Item>
                  If you are the eBIZ POC, you will automatically see your organization if
                  you registered in FEMA GO with the same email address.
                </List.Item>
                <List.Item>
                  If you are not the eBiz POC please search for them using your DUNS#
                  below and contact them to be added to your organization.
                </List.Item>
              </List>
              <p>
                You can use the{' '}
                <a
                  className="duns-link"
                  target="_blank"
                  href="https://www.dnb.com/duns-number/lookup.html"
                >
                  DUNS Number lookup tool
                </a>{' '}
                to find your DUNS number, or the{' '}
                <a
                  className="duns-link"
                  target="_blank"
                  href="http://fedgov.dnb.com/webform/displayHomePage.do"
                >
                  DUNS Request Service
                </a>{' '}
                to request a new DUNS Number.
              </p>
              {showInput && (
                <Form onSubmit={this.handleSubmit}>
                  <InlineTextBoxField
                    label="Enter your DUNS number"
                    id="dunsInput"
                    disabled={loading}
                    value={num}
                    handleChange={this.handleChange}
                    displayError={error === 'invalidId'}
                    errorMessages={this.INVALID_ID_MSG}
                  />
                  <Form.Field>
                    <Button primary disabled={loading} loading={loading}>
                      Search
                    </Button>
                  </Form.Field>
                </Form>
              )}
              {data && this.dunsResponse()}
              {error === 'notFound' && (
                <Message
                  warning
                  icon="warning sign"
                  header="Organization not found"
                  content="No organizations were found in SAM.gov matching that DUNS number. Please verify that you entered the correct DUNS number."
                />
              )}
              {error === 'multipleFound' && (
                <Message
                  warning
                  icon="warning sign"
                  header="Multiple organizations found"
                  content="Multiple organizations were found in SAM.gov matching that DUNS number. Please verify that you entered the correct DUNS number."
                />
              )}
              {error === 'samGovIssue' && (
                <Message
                  error
                  icon="warning sign"
                  header="Something went wrong"
                  content={SAMGOV_CONNECTIVITY_MSG}
                />
              )}
            </Card.Content>
          </Card>
        );
      }
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    profile: state.profile,
    userId: state.auth.loginName,
    jwt: state.auth.token,
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps)(DunsLookupCard);
